import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, watch } from "vue";
import GridView from "@/views/game/GridView.vue";
import {
  getInitValidMoves,
  getValidMoves,
} from "@/game_logic/utils/validMoves";
import { useGameStore } from "@/stores/gameStore";
import { storeToRefs } from "pinia";
import { parseMoveIndicesToString } from "@/game_logic/utils/parseMove";
import { pushMoveToFirebase } from "@/firebase/moves";


export default /*#__PURE__*/_defineComponent({
  __name: 'GridPresenter',
  setup(__props) {

const gameStore = useGameStore();
const {
  gameState: game,
  isMyTurn,
  gameMode,
  gameId,
  isGameOver,
} = storeToRefs(gameStore);
const { makeLocalMove } = gameStore;

const rows: number[] = Array.from(Array(11).keys());
const columns: number[] = Array.from(Array(11).keys());

const validMoves = ref<boolean[][]>(getInitValidMoves());

let startRow: number | null;
let startCol: number | null;

function tilePressedACB(loc: number[]) {
  if (!isMyTurn.value) return;
  if (isGameOver.value) return;
  const [row, col] = loc;
  const myPieces = game.value.myPieces;
  if (row == startRow && col == startCol) return;
  if (startRow == null || startCol == null) {
    if (!myPieces.includes(game.value.state[row][col])) {
      // Player clicked on a piece that was not its own. do nothing
      return;
    }
    console.log("setting start loc...");
    setStartLoc(row, col, game.value.state);
    return;
  }
  // Check if the destination tile makes a valid move
  if (!validMoves.value[row][col]) {
    console.log("not a valid move");
    // If the tile is a piece of the user, set new valid moves
    if (myPieces.includes(game.value.state[row][col])) {
      setStartLoc(row, col, game.value.state);
      return;
    }
    // Assume the player wants to deselect their initial stone
    resetStartLoc();
    validMoves.value = getInitValidMoves();
    return;
  }
  console.log("processing move...");
  if (gameMode.value == "local") {
    makeLocalMove(startRow, startCol, row, col);
  } else {
    const moveString = parseMoveIndicesToString(startRow, startCol, row, col);
    const moveNumber = game.value.moveHistory.length;
    pushMoveToFirebase(gameId.value!, moveString, moveNumber);
  }
  validMoves.value = getInitValidMoves();
  resetStartLoc();
}

function setStartLoc(row: number, col: number, state: string[][]) {
  startRow = row;
  startCol = col;
  validMoves.value = getValidMoves(startRow, startCol, state);
}

function resetStartLoc() {
  startRow = null;
  startCol = null;
}

watch(
  () => isGameOver.value,
  (newVal) => {
    if (newVal) {
      validMoves.value = getInitValidMoves();
    }
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(GridView, {
    "game-state": _unref(game).state,
    rows: _unref(rows),
    columns: _unref(columns),
    "valid-moves": validMoves.value,
    onTilePressed: tilePressedACB
  }, null, 8, ["game-state", "rows", "columns", "valid-moves"]))
}
}

})